import { CentralizedAnimatedLoader } from '@40seas/payments-shared';
import React, { Suspense, useState } from 'react';

const CommandMenu = React.lazy(() => import('./CommandMenu'));

const AsyncCommandMenu = ({ open, ...props }) => {
    const [hasOpened, setHasOpened] = useState(false);

    if (open && !hasOpened) {
        setHasOpened(true);
    }

    if (!hasOpened) {
        return null;
    }

    return (
        <Suspense fallback={<CentralizedAnimatedLoader backdrop />}>
            <CommandMenu open={open} {...props} />
        </Suspense>
    );
};

export default AsyncCommandMenu;
